import { decryptData } from '@/components/reusable/crypto/Cipher';
import {
  createExcelWorkBook,
  createExcelWorkBookStockLedgerReport,
  createExcelWorkLedgerDetailsReport,
  createExcelWorkLedgerReport,
} from '../export/excel/helper';
import { useLocation } from 'react-router-dom';

export const exportToExcel = ({
  data = {},
  filename = 'table_data.xlsx',
  title,
  startDate,
  endDate,
  columns,
  titleColumn,
  hideDate,
  isTotalBold,
  isStockledgerReport,
  isLedgerReport,
  totalData,
  isLedgerDetailsReport = false,
  totalExcelFooter,
  ledgerName,
  boldRowIndexes,
}) => {
  const userData = decryptData(localStorage.getItem('userData'));


  isStockledgerReport
    ? createExcelWorkBookStockLedgerReport(
        data,
        {
          companyName: userData?.companyName,
          address: userData?.branchAddress,
          email: userData?.branchEmail,
          phone: userData?.branchNumber,
        },
        filename,
        title,
        startDate,
        endDate,
        columns,
        hideDate,
        isTotalBold,
      )
    : isLedgerReport
      ? createExcelWorkLedgerReport(
          data,
          {
            companyName: userData?.companyName,
            address: userData?.branchAddress,
            email: userData?.branchEmail,
            phone: userData?.branchNumber,
          },
          filename,
          title,
          startDate,
          endDate,
          columns,
          hideDate,
          isTotalBold,
          totalData,
        )
      : isLedgerDetailsReport
        ? createExcelWorkLedgerDetailsReport(
            data,
            {
              companyName: userData?.companyName,
              address: userData?.branchAddress,
              email: userData?.branchEmail,
              phone: userData?.branchNumber,
            },
            filename,
            title,
            startDate,
            endDate,
            columns,
            hideDate,
            isTotalBold,
            totalData,
            totalExcelFooter,
            ledgerName,
          )
        : createExcelWorkBook(
            data,
            {
              companyName: userData?.companyName,
              address: userData?.branchAddress,
              email: userData?.branchEmail,
              phone: userData?.branchNumber,
            },
            filename,
            title,
            startDate,
            endDate,
            columns,
            hideDate,
            isTotalBold,
            titleColumn,
            boldRowIndexes,
          );
};
